import React from 'react'

interface IProps<T = unknown>{
    value:T,
    delay?:number,
    callback?:(value:T)=>void
}
export function useDebounce<T=unknown>({value, delay, callback}:IProps<T>) {

    const [debouncedValue, setDebouncedValue] = React.useState(value)

    React.useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

        return () => clearTimeout(timer)
    }, [value, delay]);

    React.useEffect(() => {
        if(typeof callback === 'function'){
            callback(debouncedValue)
        }
    }, [debouncedValue])

    return {
        debouncedValue,
        setDebouncedValue
    }
}
